import cn from "clsx";
import Collapse from "@crehana/icons/outline/Collapse";
import { Tooltip, transition } from "@crehana/ui";
import { SIDEBAR_COLLAPSED_WIDTH, SIDEBAR_EXPANDED_WIDTH } from "../../../constants";
import { jsx as _jsx } from "react/jsx-runtime";
var ActionCollapse = function ActionCollapse(_ref) {
  var isOpen = _ref.isOpen,
    _ref$isDark = _ref.isDark,
    isDark = _ref$isDark === void 0 ? false : _ref$isDark,
    title = _ref.title,
    _ref$iconCollapse = _ref.iconCollapse,
    Icon = _ref$iconCollapse === void 0 ? Collapse : _ref$iconCollapse,
    onClick = _ref.onClick,
    isSidebarV2Enabled = _ref.isSidebarV2Enabled,
    hasTalentProduct = _ref.hasTalentProduct;
  var handleClick = function handleClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    onClick();
  };
  var leftPosition = isOpen ? SIDEBAR_EXPANDED_WIDTH : SIDEBAR_COLLAPSED_WIDTH;
  var topPosition = hasTalentProduct ? 132 : 80;
  return /*#__PURE__*/_jsx(Tooltip, {
    isDark: isDark,
    label: title,
    children: /*#__PURE__*/_jsx("button", {
      type: "button",
      className: cn('fixed rounded-full border-4 border-solid flex items-center justify-center', isDark ? 'text-white border-gray-main-dark-mode bg-base-light-dark-mode' : 'border-gray-light bg-white hover:bg-gray-100'),
      onClick: handleClick,
      style: {
        top: isSidebarV2Enabled ? topPosition : 56,
        left: "calc(".concat(leftPosition, " - 16px)"),
        transform: "rotate(".concat(isOpen ? '0deg' : '-180deg', ")"),
        transition: transition(['transform', 'left']),
        width: 36,
        height: 36
      },
      children: /*#__PURE__*/_jsx(Icon, {
        ignoreColor: true,
        className: cn('fill-current flex-shrink-0', {
          'text-black': !isDark,
          'text-white': isDark
        }),
        size: isSidebarV2Enabled ? 20 : 14
      })
    })
  });
};
export default ActionCollapse;